<script setup>
import {ref, onMounted, onBeforeUnmount, computed} from 'vue'
import {router} from "@inertiajs/vue3";
import {useDisplay} from 'vuetify'

const display = useDisplay()
const componentPosition = ref(null)
const showScrollToTopButton = ref(false)
const mobileMenuOpen = ref(false)

const buttonClass = computed(() => {
    return {
        'position-fixed': true,
        'scroll-to-top-desktop': !display.mobile.value,
        'scroll-to-top-mobile': display.mobile.value,
        'menu-open': display.mobile.value && mobileMenuOpen.value
    }
})

const onScroll = () => {
    if (componentPosition.value) {
        const rect = componentPosition.value.$el.getBoundingClientRect()
        showScrollToTopButton.value = rect.top < 0
    }
}

const checkMobileMenuState = () => {
    // Check if mobile menu drawer is open by looking for an active navigation drawer
    const activeDrawer = document.querySelector('.v-navigation-drawer--active')
    mobileMenuOpen.value = !!activeDrawer
}

const toTop = () => {
    const params = route().params

    if (params.page && params.page !== "1"){
        delete params.page
        router.get(route('product.list', params), [], { preserveScroll:true})
    }

    +window.scrollTo({top: 0, behavior: 'smooth'})
}

// Create a ref for the observer so we can disconnect it later
const observer = ref(null)

onMounted(() => {
    window.addEventListener('scroll', onScroll)

    // Set up a MutationObserver to detect changes in the DOM
    // This will help us detect when the mobile menu is opened/closed
    observer.value = new MutationObserver(checkMobileMenuState)
    observer.value.observe(document.body, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
    })

    // Initial check
    checkMobileMenuState()
})

onBeforeUnmount(() => {
    window.removeEventListener('scroll', onScroll)

    if (observer.value) {
        observer.value.disconnect()
    }
})
</script>

<template>
    <v-sheet ref="componentPosition" position="absolute" class="text-center">
        <v-btn v-show="showScrollToTopButton" @click="toTop" icon="mdi-arrow-up"
               :class="buttonClass" color="primary"/>
    </v-sheet>
</template>

<style scoped>
.scroll-to-top-desktop {
    right: 2%;
    bottom: 5%;
    z-index: 60;
}

.scroll-to-top-mobile {
    right: 16px;
    bottom: 16px;
    z-index: 100;
    transition: right 0.3s ease;
}

.menu-open {
    right: 296px;
}
</style>
